import { useState } from 'react'
import { Dialog } from '#app/shared/ui/popups/Dialog.js'
import CheckModalContent from './checkModalContent'

type Props = {}

export default function CheckModal({}: Props) {
  const [open, setOpen] = useState(false)
  return (
    <Dialog
      className={`!rounded-none !border-0 !border-none`}
      overlayClassName="!rounded-none !border-0 !border-none bg-transparent"
      open={open}
      onClose={() => setOpen(false)}
      hideIcon
      containerClassName="overflow-hidden !border-none"
      variant="fullscreen"
    >
      <CheckModalContent setOpen={setOpen} />
    </Dialog>
  )
}
